/**
 * 宠物小游戏模块（6c2b）：贪吃猫狗、宠物篮球、宠物战机的入口页。全屏页（bareRoutes），不挂底栏；
 * 登录与入住守卫沿用小窝用的 WorldGate。入口在小窝（快捷栏「和 TA 玩」、点 TA 的面板），I 03:2x 批的入口方案。
 * 规则核心在 core（B），界面组件在 ui；成绩不存，没有后端。
 */
import { defineModule } from "@/shared/modules/types";
import { WorldGate } from "@/features/world_map/WorldGate";
import { PlayGamePage } from "./pages/PlayGamePage";
import { PlayHubPage } from "./pages/PlayHubPage";

export default defineModule({
  id: "pet_arcade",
  bareRoutes: [
    { path: "play", element: <WorldGate><PlayHubPage /></WorldGate> },
    { path: "play/snake", element: <WorldGate><PlayGamePage game="snake" /></WorldGate> },
    { path: "play/basket", element: <WorldGate><PlayGamePage game="basket" /></WorldGate> },
    { path: "play/flight", element: <WorldGate><PlayGamePage game="flight" /></WorldGate> },
  ],
});
